import Alert from '@storeblocks/alert';
import { type FC } from 'react';

import { OrderType } from '@/api/order/models/OrderType';
import { useTexts } from '@/hooks/useTexts';

interface Props {
  orderType: OrderType.Subscription | OrderType.Redemption;
}

export const MultipleCurrenciesAlert: FC<Props> = ({ orderType }) => {
  const texts = useTexts();

  const textMap = {
    [OrderType.Subscription]: {
      title: texts.orders.form.table.subscription.summary.title,
      text: texts.orders.form.table.subscription.summary.text,
    },
    [OrderType.Redemption]: {
      title: texts.orders.form.table.redemption.summary.title,
      text: texts.orders.form.table.redemption.summary.text,
    },
  };

  return (
    <Alert
      title={textMap[orderType].title}
      description={textMap[orderType].text}
      fluid
    />
  );
};
